import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AngularSplitModule } from 'angular-split';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppStateModule } from './app-state.module';
import { AppComponent } from './app.component';

import { QuillModule } from 'ngx-quill';
import { SearchModule } from './search/search.module';
import { LoginModule } from './login/login.module';
import { SharedModule } from '@shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from "@angular/common";
import { MockBackendInterceptor } from '@shared/interceptors/mock-backend.interceptor';
import { CallbackRedirectComponent } from './callback-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    CallbackRedirectComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    AppStateModule.forRoot(),
    AngularSplitModule,
    QuillModule.forRoot(),
    SharedModule,
    SearchModule,
    LoginModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MockBackendInterceptor,
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
